import moment from 'moment';
import _collection from 'lodash'
import React from 'react';

export function sendClientError(error) {
  const errorData = {
    message: error.message || error,
    stacktrace: error.stack || "No stack trace available",
    userAgent: navigator.userAgent,
  };

  $.ajax({
    method: "POST",
    url: "/log-client-error",
    data: errorData,
  }).fail(function (err) {
    console.log(err);
  });
}

export class Input {
  name;
  $;
  specialType;

  /**
   *
   * @param {string} name Input name
   * @param {Element} $element
   * @param {null|"select2"} specialType
   */
  constructor(name, $element, specialType = null) {
    this.name = name;
    this.$ = $element;

    switch (specialType) {
      case null:
        this.specialType = "standard";
      case "select2":
        //Add type cases as supported
        this.specialType = specialType;
        break;
      default:
        throw new Error(`Type ${specialType} not supported`);
    }
  }

  get $stylingTarget() {
    switch (this.specialType) {
      case "select2":
        return this.$.nextElementSibling.querySelector(".select2-selection");
      case "standard":
      default:
        return this.$;
    }
  }
}

/**
 * Check if an AJAX request is a validation error on fail. Apply onError and onErrorClear on inputs.
 * @param {jqXHR} error 
 * @param {Input[]} inputs 
 * @param {(Element) => {}} onError callback for when validation doesn't pass
 * @param {(Element) => {}} onErrorClear callback for when validation passes
 * @returns {boolean} Is it a validation fail 
 */
export function validationActions(
  error,
  inputs,
  onError = ($element) => {},
  onErrorClear = ($element) => {}
) {
  const namesVsResult = {};
  inputs.forEach((input) => {
    namesVsResult[input.name] = {
      input: input,
      isError: false,
    };
  });

  const isValidationError = processAjaxValidationError(
    error,
    (field, messages) => {
      namesVsResult[field].isError = true;
    }
  );

  for (const name in namesVsResult) {
    if (Object.prototype.hasOwnProperty.call(namesVsResult, name)) {
      const result = namesVsResult[name];

      const $target = result.input.$stylingTarget;

      if (result.isError) {
        onError($target);
      } else {
        onErrorClear($target);
      }
    }
  }

  return isValidationError;
}

//Jquery AJAX validation .fail error, returns false if not a validation error
//The AJAX should have the Accept: 'application/json' header
/**
 * 
 * @param {jqXHR} err 
 * @param {(field: string, messages: string[]) => void} onFieldError A callback providing a field name, and an array of error messages. Called for each invalid field.
 */
export function processAjaxValidationError(err, onFieldError)
{
  if(err.status === undefined || err.status !== 422) return false;//Not a validation error
  const fieldErrors = JSON.parse(err.responseText).errors;
  
  for (const field in fieldErrors) {
    if (Object.prototype.hasOwnProperty.call(fieldErrors, field)) {
      const messages = fieldErrors[field];
      onFieldError(field, messages);
    }
  }

  return true;
}


export function getSystemSetting(key, callback){
  $.ajax({
    method:"GET",
    url:"/admin/settings/fetch",
    data:{
        key:key
    }
  }).done(function(data){
      callback(data);
  }).fail(function(err){
    console.log(err);
    console.log("something went wrong..");
  });

}
export function isStringEmpty(str){
  
  if(str.trim() == "" || str == "undefined"){
    return true;
  }

  return false;
}

export function setDropdownOptions($dropdown, list, defaultIndex = 0){
  list.forEach((option) => {
    $dropdown.append('<option value="' + option.id + '">' + option.name + '</option>')
  });

  $dropdown.prop('selectedIndex', defaultIndex).change();
  
}

export function constructConflictList(conflicts, array) {
  conflicts.forEach((conflict) => {
    array.push('<tr><td>' + moment.unix(conflict.date).format('D MMMM YYYY') + '</td><td>' + conflict.reason +  '</td></tr>');
  });
  return array.join('');
}

export function constructCreationOptions(options, array = [], idKey="id") {
  options.forEach((option) => {
    array.push('<option value="' + option[idKey] + '">' + option.name + '</option>');
  });
  return array.join('');
}

export function constructIncidentOptions(options, array) {
  options.forEach((option, index) => {
    array.push('<option value="' + option.id + '" data-roleindex=' + index + '>' + option.name + '</option>');
  });
  return array.join('');
}

export function setSideNavFullHeight() {
  let contentHeight = $('.main-inner').height();
  //console.log(contentHeight);
  //console.log($(window).height());
  if (contentHeight > $(window).height()) {
   $('#main-menu').height(contentHeight);
  }
}

export function alertRequestWait() {
  return $.alert({
    theme: "custom small",
    title: "File Export",
    animateFromElement: false,
    content:
      "Your request is being processed and will download shortly. Please do not close your browser until your download is complete.",
    buttons: {
      close: {
        btnClass: "button-primary",
        text: "Okay",
      },
    },
  });
}

export function alertRequestCompletionThroughNotification() {
  return $.alert({
    theme: "custom small",
    title: "File Export",
    animateFromElement: false,
    content:
      "Your request is being processed and may take some time to complete. A notification" +
      " will appear in your roster notifications when it is ready. Click on the link to download.",
    buttons: {
      close: {
        btnClass: "button-primary",
        text: "Okay",
      },
    },
  });
}

export function constructPatternPopup(roleOptions, rosterCodeOptions, resourceOptions) {// TODO: move to Roster/Assets/helpers.js
  return '<span class="popup-sub-title">Create Work Pattern</span>' +

  '<div class="common-pattern-checkbox"><input id="pattern-type" type="checkbox" title="Check to create common work pattern" />' +
  '<label for="pattern-type">Common Work Pattern</label></div>' +

  '<div class="create-pattern-wrapper">' +

  '<label for="workday-input">W</label>' +
  '<input id="workday-input" type="number" value="1" min="1" required />' +
  '<span class="pattern-legend">Workday</span>' +
  '<button id="add-workday" title="add work day" class="button-default">Add</button>' +

  '<label class="grey" for="ro-input">RO</label>' +
  '<input id="ro-input" type="number" value="1" min="1" required />' +
  '<span class="pattern-legend">Rostered Off</span>' +
  '<button id="add-ro" title="add ro" class="button-default">Add</button>' +

  '<div id="pattern-display"></div>' +
  '</div>' +

  '<form action="" class="roster-day-form work-pattern-creation">' +

  '<div class="input-3col">' +
  '<label for="roles">Role<span id="warning-user-not-qualified">Not Qualified</span></label>' +
  '<select id="roles">' +
  '<option value="0">None</option>' +
  roleOptions +
  '</select>' +

  '<label for="resource-option">Categories/Resources</label>' +
  '<select disabled id="resource-option">' +
  '<option value="">None</option>' +
  resourceOptions +
  '</select>' +


  '<label for="item-option">Task</label>' +
  '<select id="item-option" disabled>' +
  '<option value="">None</option>' +
  '</select>' +

  '</div>' +

  '<div class="input-3col">' +
  '<label for="roster-status">Status <!--span class="required-indicator">*</span--></label>' +
  '<select id="roster-status">' +
  '<option value="">None</option>' +
  rosterCodeOptions +
  '</select>' +

  '<label for="description-option">Description</label>' +
  '<select id="description-option" disabled>' +
  '<option value="">None</option>' +
  '</select>' +

  '</div>' +

  '<div class="input-3col">' +
  '<label for="comment">Comment</label>' +
  '<textarea id="comment"></textarea>' +

  '<button id="assign-pattern-props" class="button-primary">Apply</button>' +
  '</div>' +

  '</form>'
}

export const baseUrl = window.location.protocol + "//" + window.location.host;

export const isMobile = function() {
  return $('body').hasClass('mobile');
}

export const readOnly = function() {
  if ($('body').hasClass('user')) {
    return true;
  }
};

export const showToggleMenu = function() {
  if ($('body').hasClass('group-admin') || $('body').hasClass('section-admin') || $('body').hasClass('senior-admin')) {
    return true;
  }
};

export function handleNormalUserMenu() {
  $('header.user-normal-menu .hamburger').click(function(e) {
      e.preventDefault();

      var _this = $(this);
      var nav = $('header nav');

      if (!_this.hasClass('disabled')) {
          _this.addClass('disabled');
          _this.toggleClass('active');

          nav.slideToggle(250, function() {
              _this.removeClass('disabled');
          });
      }
  });
}

export function checkIsWeekend(timestamp) {
  return [0,6].indexOf(moment.unix(timestamp).day()) !== -1;
}

export function mergeDedupe(arr) {
  return [...new Set([].concat(...arr))];
}

export function getUniqueElementsFromArray(array1, array2){

  let filteredArray =  array1.filter(function(item) { 
    return array2.indexOf(item) == -1; 
  });

  return filteredArray;
}

export function generateAllowedDates(startDate, maxAllowedNumberOfDays){
	let allowedDates = [];

	let date = startDate;
	allowedDates[0] = (date.getDate()) + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
	for (let index = 1; index < maxAllowedNumberOfDays ; index++) {
		date.setDate(date.getDate() + 1);
		allowedDates[index] = (date.getDate()) + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
	}
	return allowedDates;
}

export function isDateEnabled(startDate, date){
  
	let maxAllowedNumberOfDays = 14;
	let allowedDates = [];
	if(startDate == null){
		return false;
	}

	allowedDates = generateAllowedDates(startDate, maxAllowedNumberOfDays);
	
	let dmy = date.getDate() + "-" + (date.getMonth()+1) + "-" + date.getFullYear();

	if ($.inArray(dmy, allowedDates) != -1) {
		return true;
	} else {
		return false;
	}

}

export function UserName({canView, canEdit, name, uuid}) {
  if (!canView && !canEdit) return name;
  const link =
    baseUrl + "/admin/users/" + uuid + ((canEdit) ? "/edit" : "/view");
  return (
    <a className="roster-profile-link" target="_blank" href={link}>
      {name}
    </a>
  );
}

export function generateDisplayStaffName(firstName, lastName, prefix, postfix){


  let name = "";
  if(lastName == "" && firstName == "" ){
    name =  "None Provided";
    return name;
  }

  if(firstName != "" && lastName != ""){

    name  = lastName + ", " + firstName;

    addPrefix();
    addPostfix();
  
    return name;
  }

  if(firstName != ""){
    name =  firstName;
    addPrefix();
    addPostfix();
    return name;
  }

  if(lastName != ""){
    name = lastName;
    addPrefix();
    addPostfix();
    return name;
  }

  function addPostfix() {
    if (postfix != undefined) {
      name = name + postfix;
    }
  }

  function addPrefix() {
    if (prefix != undefined) {
      name = prefix + name;
    }
  }
}

export function formatFileSize(size){

  let l = 0, n = parseInt(size, 10) || 0;

  while(n >= 1000 && l < 8 && ++l){
      n = n/1000;
  }

  const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']; //From testing, only goes up to EB before size issues

  return(n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
}

export function generateDisplayRoleName(role){

  if(role == ""){
    return "None Provided";
  }

  return role;

}

export function generateDisplayString(string, prefix, postfix){

  if(prefix != undefined){
    string = prefix + string;
  }

  if(postfix != undefined){
    string = string + postfix;
  }

  return string;
}

export function convertToSlug(text)
{
    return text
        .toLowerCase()
        .replace(/ /g,'_')
        .replace(/[^\w-]+/g,'')
        ;
}

export function deepCopyObject(obj)
{

  return JSON.parse(JSON.stringify(obj));

} 

export function confirmPopup(title, content){
  return new Promise((resolve, reject) => {
    $.confirm({
        theme: 'custom',
        closeIcon: true,
        animateFromElement: false,
        title: title,
        content: content,
        buttons: {
          reload: {
              text: 'Confirm',
              btnClass: 'button-primary',
              action: function () {
                resolve({ "click" : "yes"});
              }
          },
          cancel: {
            text: 'Cancel',
            btnClass: 'button-default',
            action: function () {
              resolve({"click": "no"});
            },
          }
        }
      });
  });
}

export function constructIncidentAddMemberStatus(name, role){
  return "User " + name + " has been added successfully as " + role + ".";
}


export function constructIncidentAddUnit(unit){
  return "Unit " + unit + " has been added successfully.";
}


export function constructIncidentRemoveUnit(unit){
  return "Unit " + unit + " has been removed successfully.";
}


export function constructIncidentRemoveMemberStatus(name){
  return "User " + name + " has been removed successfully.";
}

export function constructIncidentUpdateStatus(){
  return "Updated successfully.";
}

export function replaceElement($element, replaceText = ""){

  $element.html(replaceText)
}

export function displayIncidentStatus(key, value){

  if (typeof(Storage) !== "undefined") {
    localStorage.setItem(key, value);
  }
  if (value.length > 0)
    $(".last-update").html("<div class='incident-update-status incident-success'>" + value + "</div>");
  else $(".last-update").html("");
}

export function displayIncidentFailureStatus(key, value) {
  if (typeof Storage !== "undefined") {
    localStorage.setItem(key, value);
  }
  if (value.length > 0)
    $(".last-failure").html(
      "<div class='incident-update-status alert'>" + value + "</div>"
    );
  else $(".last-failure").html("");
}

export function displayLastIncidentStatus(key){

  if (typeof(Storage) !== "undefined") {
    let incidentUpdateStatus = localStorage.getItem(key);
    if(incidentUpdateStatus != null && incidentUpdateStatus != '') {
      $(".last-update").html("<div class='incident-update-status incident-success'>" + incidentUpdateStatus + "</div>");
    }
  }else{
    $(".last-update").html("Browser Not Supported");
  }
}

export function displayLastIncidentFailureStatus(key){

  if (typeof(Storage) !== "undefined") {
    let incidentUpdateStatus = localStorage.getItem(key);
    if(incidentUpdateStatus != null && incidentUpdateStatus != '') {
      $(".last-failure").html("<div class='incident-update-status alert'>" + incidentUpdateStatus + "</div>");
    }
  }
}

export function alertPopup(
  title = "Whoops, looks like something went wrong", 
  content = "Please, send an email to cimara.support@372digital.com.au briefly explaining what you were trying to do and the last action you did that resulted into this error."
){
  return new Promise((resolve, reject) => {
    $.confirm({
        theme: 'custom',
        closeIcon: true,
        animateFromElement: false,
        title: title,
        content: content,
        buttons: {
          reload: {
              text: 'Okay',
              btnClass: 'button-primary',
              action: function () {
                resolve({ "click" : "yes"});
              }
          }
        }
      });
  });
}

export function getAllSystemSettings(){
  return window.setting;
}

export function getSystemSettingBykeys(typeKey, settingKey){

  let settings = window.setting;

  let settingType = settings[typeKey];

  return _collection.find(settingType, function(o){
    if(o.key == settingKey){
      return o;
    }
  }); 
}

export function createPromiseRequest(settings, successCallback, errCallback){
  return new Promise((resolve, reject)=>{
    $.ajax(settings).done((res) => {
      successCallback(res);
      resolve();
    }).fail((err) => {
      if(errCallback != undefined){
        errCallback(err);
      }
        reject();
    });
  });
}


jQuery.fn.reverse = [].reverse;

